import { Box } from '@mui/material';

import LanguageSwitcher from './LanguageSwitcher';

function HeaderButtons() {
  return (
    <Box>
      {/* TODO: QQuando trabalhar com notificações, aqui será o sino */}
      {/* <HeaderNotifications /> */}
      <LanguageSwitcher />
    </Box>
  );
}

export default HeaderButtons;
